import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import ViewObservationFormTableCellButton from "../ViewObservationFormTableCellButton/ViewObservationFormTableCellButton";

export interface IndividualObservationTableCellProps {
	cellValue?: TableCellValue;

	userId?: number;
}

const IndividualObservationTableCell: FC<
	IndividualObservationTableCellProps
> = ({ cellValue, userId }) => {
	const { control, setValue } = useFormContext<ReportDetailForm>();

	const { showCompliantReport } = useWatch({
		control,
		name: "filters"
	});

	const handleObservationSuccessButtonClick = () => {
		if (!cellValue || !cellValue.month) return;

		setValue("filters.userId", userId);
		setValue("filters.month", cellValue.month);
	};

	if (!cellValue || cellValue.month === null) {
		return <span className="text-zinc-300">&mdash;</span>;
	}

	const { complete, compliant } = cellValue;

	if (!showCompliantReport) {
		if (complete === 0) {
			return <span>{complete}</span>;
		}

		return (
			<ViewObservationFormTableCellButton
				onClick={userId ? handleObservationSuccessButtonClick : undefined}
				totalNumObservations={complete}
			>
				{complete}
			</ViewObservationFormTableCellButton>
		);
	}

	// calculate the percentage and floor it, because 99% is still not 100% compliant.
	const total = Math.floor((compliant / complete) * 100);

	if (isNaN(total)) {
		return <span className="text-zinc-300">&mdash;</span>;
	}

	if (total === 100) {
		return (
			<ViewObservationFormTableCellButton
				onClick={userId ? handleObservationSuccessButtonClick : undefined}
				totalNumObservations={complete}
				completed={true}
				showIcon={true}
			/>
		);
	}

	if (total === 0 && userId) {
		return (
			<ViewObservationFormTableCellButton
				onClick={userId ? handleObservationSuccessButtonClick : undefined}
				totalNumObservations={complete}
				completed={false}
				showIcon={true}
			/>
		);
	}

	return <span>{`${total}%`}</span>;
};

export default IndividualObservationTableCell;
